
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/new-launches",
      function () {
        return require("private-next-pages/cars/new-launches/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/new-launches"])
      });
    }
  